module.exports = __webpack_public_path__ + "img/sync.9ee21a10.svg";